import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import JewelryManufacturingPage from "./pages/JewelryManufacturingPage";
import DiamondManufacturingPage from "./pages/DiamondManufacturingPage";
import JewelryPage from "./pages/JewelryPage";
import DiamondPage from "./pages/DiamondPage";
import ContactPage from "./pages/ContactPage";
import AppointmentPage from "./pages/AppointmentPage";
import EthicalStandardsPage from "./pages/EthicalStandardsPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/jewelry-manufacturing" element={<JewelryManufacturingPage />} />
        <Route path="/diamond-manufacturing" element={<DiamondManufacturingPage />} />
        <Route path="/jewelry" element={<JewelryPage />} />
        <Route path="/diamonds" element={<DiamondPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/make-an-appointment" element={<AppointmentPage />} />
        <Route path="/ethical-standards" element={<EthicalStandardsPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
